document.addEventListener('DOMContentLoaded', function () {
  console.log('✅ swatch-switch.js ready (using data-media-id)');

  const swatchRadios = document.querySelectorAll('.swatch-wrapper input[type="radio"]');
  const travelCaseBundleRadios = document.querySelectorAll('input[name="travel_case_bundle"]');

  swatchRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      const swatchWrapper = this.closest('.swatch-wrapper');
      const mediaId = swatchWrapper?.dataset.mediaId;

      console.log('🎨 Color selected:', this.value, '| 🖼 media-id:', mediaId);

      // Update hidden variant dropdown to ensure correct variant is sent to cart
      updateHiddenVariantDropdown();

      if (mediaId) {
        // 🔍 Find the matching thumbnail button with that media ID
        const matchingThumb = document.querySelector(
          `.product-gallery--media-thumbnail[data-media="${mediaId}"]`
        );

        console.log('🔍 Looking for thumbnail with data-media:', mediaId);
        console.log('📸 Found matching thumbnail:', matchingThumb);

        if (matchingThumb) {
          console.log('📸 Clicking matching thumbnail:', matchingThumb);
          matchingThumb.click();
        } else {
          console.warn('⚠️ No matching thumbnail found for media-id', mediaId);
          
          // Debug: Log all available thumbnails
          const allThumbnails = document.querySelectorAll('.product-gallery--media-thumbnail');
          console.log('📋 All available thumbnails:', allThumbnails);
          allThumbnails.forEach((thumb, index) => {
            console.log(`📋 Thumbnail ${index}:`, {
              dataMedia: thumb.dataset.media,
              dataMediaType: thumb.dataset.mediaType,
              selected: thumb.dataset.productGallerySelected
            });
          });
        }
          } else {
      console.warn('⚠️ No media-id found on swatch wrapper');
    }
  });

  // 🎒 Handle Travel Case Bundling Selection
  travelCaseBundleRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      const swatchWrapper = this.closest('.swatch-wrapper');
      const mediaId = swatchWrapper?.dataset.mediaId;
      const material = swatchWrapper?.dataset.material;
      const variantId = swatchWrapper?.dataset.variantId;

      console.log('🎒 Travel Case selected:', this.value, '| 🖼 media-id:', mediaId, '| 📦 material:', material, '| 🆔 variant-id:', variantId);

      // Store the selected travel case for cart bundling
      window.selectedTravelCase = {
        material: material,
        variantId: variantId,
        value: this.value
      };

      if (mediaId && material !== 'none') {
        // 🔍 Find the matching thumbnail button with that media ID
        const matchingThumb = document.querySelector(
          `.product-gallery--media-thumbnail[data-media="${mediaId}"]`
        );

        console.log('🔍 Looking for travel case thumbnail with data-media:', mediaId);
        console.log('📸 Found matching travel case thumbnail:', matchingThumb);

        if (matchingThumb) {
          console.log('📸 Clicking matching travel case thumbnail:', matchingThumb);
          matchingThumb.click();
        } else {
          console.warn('⚠️ No matching travel case thumbnail found for media-id', mediaId);
          
          // Debug: Log all available thumbnails
          const allThumbnails = document.querySelectorAll('.product-gallery--media-thumbnail');
          console.log('📋 All available thumbnails:', allThumbnails);
          allThumbnails.forEach((thumb, index) => {
            console.log(`📋 Thumbnail ${index}:`, {
              dataMedia: thumb.dataset.media,
              dataMediaType: thumb.dataset.mediaType,
              selected: thumb.dataset.productGallerySelected
            });
          });
        }
      } else if (material === 'none') {
        console.log('🎒 No travel case selected, reverting to main product image');
        window.selectedTravelCase = null;
        // Find and click the first thumbnail (main product image)
        const firstThumb = document.querySelector('.product-gallery--media-thumbnail');
        if (firstThumb) {
          firstThumb.click();
        }
      } else {
        console.warn('⚠️ No media-id found on travel case swatch wrapper');
      }
    });

  // 🛒 Handle form submission to ensure correct variant is sent
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      console.log('🛒 Form submission detected');
      
      // Get the current selected variant from the main product select
      const mainProductSelect = document.querySelector('.product-select');
      if (mainProductSelect) {
        console.log('🛒 Submitting variant ID:', mainProductSelect.value);
      }
      
      // Get the selected travel case if any
      if (window.selectedTravelCase) {
        console.log('🛒 Selected travel case:', window.selectedTravelCase);
      }
    });
  }
});
  });

  // Function to update the hidden variant dropdown based on selected options
  function updateHiddenVariantDropdown() {
    const hiddenDropdown = document.getElementById('hidden-variant-dropdown');
    if (!hiddenDropdown) {
      console.warn('⚠️ Hidden variant dropdown not found');
      return;
    }

    // Check if this is a Travel Case product (single option: Material only)
    const productTitle = document.querySelector('.product-title');
    const isTravelCaseProduct = productTitle && (
      productTitle.textContent.toLowerCase().includes('travel case') ||
      productTitle.textContent.toLowerCase().includes('travel cases')
    );

    const selectedOptions = window.getSelectedProductOptions();
    const selections = window.getColorAndFabricSelections();

    console.log('🎯 Selected options (main product):', selectedOptions);
    console.log('🎒 Is Travel Case product:', isTravelCaseProduct);

    // ✅ Handle Travel Case products (single option: Material)
    if (isTravelCaseProduct) {
      if (selectedOptions.length === 0) {
        console.warn('⚠️ No material selected for Travel Case');
        hiddenDropdown.value = '';
        const mainProductSelect = document.querySelector('.product-select');
        if (mainProductSelect) {
          mainProductSelect.value = '';
        }
        const addToCartButton = document.querySelector('.add-to-cart-button');
        if (addToCartButton) {
          addToCartButton.disabled = true;
          addToCartButton.style.opacity = '0.5';
          addToCartButton.title = 'Please select a material';
        }
        return;
      }

      // For Travel Case, Material is in option1 (stored as data-color in hidden dropdown)
      const selectedMaterial = selectedOptions[0];
      const variantOptions = hiddenDropdown.querySelectorAll('option');
      let matchingVariant = null;

      variantOptions.forEach(option => {
        const variantMaterial = option.dataset.color; // For Travel Case, option1 (Material) is stored as data-color
        
        if (variantMaterial === selectedMaterial) {
          matchingVariant = option;
        }
      });

      if (matchingVariant) {
        console.log('✅ Updating hidden dropdown to Travel Case variant:', matchingVariant.value);
        hiddenDropdown.value = matchingVariant.value;
        
        const mainProductSelect = document.querySelector('.product-select');
        if (mainProductSelect) {
          mainProductSelect.value = matchingVariant.value;
          const changeEvent = new Event('change', { bubbles: true });
          mainProductSelect.dispatchEvent(changeEvent);
        }
        
        const addToCartButton = document.querySelector('.add-to-cart-button');
        if (addToCartButton) {
          addToCartButton.disabled = false;
          addToCartButton.style.opacity = '1';
          addToCartButton.title = '';
        }
      } else {
        console.warn('⚠️ No matching Travel Case variant found for material:', selectedMaterial);
        hiddenDropdown.value = '';
        const mainProductSelect = document.querySelector('.product-select');
        if (mainProductSelect) {
          mainProductSelect.value = '';
        }
        const addToCartButton = document.querySelector('.add-to-cart-button');
        if (addToCartButton) {
          addToCartButton.disabled = true;
          addToCartButton.style.opacity = '0.5';
          addToCartButton.title = 'Please select a valid material';
        }
      }
      return;
    }

    // ✅ Handle Pillow Sets (two options: Color + Fabric)
    const hasColor = !!selections.color;
    const hasFabric = !!selections.fabric;
    
    if (!hasColor || !hasFabric) {
      console.warn('⚠️ Incomplete selection - need both color and fabric');
      hiddenDropdown.value = '';
      
      const mainProductSelect = document.querySelector('.product-select');
      if (mainProductSelect) {
        mainProductSelect.value = '';
      }
      
      const addToCartButton = document.querySelector('.add-to-cart-button');
      if (addToCartButton) {
        addToCartButton.disabled = true;
        addToCartButton.style.opacity = '0.5';
        addToCartButton.title = 'Please select both color and material';
      }
      
      return;
    }

    // Find the matching variant for Pillow Sets (Color + Fabric)
    const variantOptions = hiddenDropdown.querySelectorAll('option');
    let matchingVariant = null;
    const colorValue = selections.color;
    const fabricValue = selections.fabric;

    variantOptions.forEach(option => {
      const optionData = option.dataset;
      const variantColor = optionData.color;
      const variantFabric = optionData.fabric;

      // Check if this variant matches our selected options (color + fabric only)
      if (window.variantMatchesColorAndFabric({ option1: variantColor, option2: variantFabric }, colorValue, fabricValue)) {
        matchingVariant = option;
      }
    });

    if (matchingVariant) {
      console.log('✅ Updating hidden dropdown to variant:', matchingVariant.value);
      hiddenDropdown.value = matchingVariant.value;
      
      const mainProductSelect = document.querySelector('.product-select');
      if (mainProductSelect) {
        console.log('✅ Updating main product select to variant:', matchingVariant.value);
        mainProductSelect.value = matchingVariant.value;
        
        const changeEvent = new Event('change', { bubbles: true });
        mainProductSelect.dispatchEvent(changeEvent);
      } else {
        console.warn('⚠️ Main product select not found');
      }
      
      const addToCartButton = document.querySelector('.add-to-cart-button');
      if (addToCartButton) {
        addToCartButton.disabled = false;
        addToCartButton.style.opacity = '1';
        addToCartButton.title = '';
      }
    } else {
      console.warn('⚠️ No matching variant found for selected options:', selectedOptions);
      
      hiddenDropdown.value = '';
      
      const mainProductSelect = document.querySelector('.product-select');
      if (mainProductSelect) {
        mainProductSelect.value = '';
      }
      
      const addToCartButton = document.querySelector('.add-to-cart-button');
      if (addToCartButton) {
        addToCartButton.disabled = true;
        addToCartButton.style.opacity = '0.5';
        addToCartButton.title = 'Please select valid color and material combination';
      }
    }
  }
});
